export const categories = [
  { id: 'all', name: 'All Collections', count: 177 },
  { id: 'bank-series', name: 'Bank Series', size: '100x300 MM', count: 9, description: 'Premium glossy wall tiles with 10.5mm thickness. Perfect for modern kitchens and bathrooms.', gallery: ['/images/tiles/bank-series/bank-000.png', '/images/tiles/bank-series/bank-003.png', '/images/tiles/bank-series/bank-series-003.png'] },
  { id: 'coco-series', name: 'COCO Series', size: 'Various', count: 5, description: 'Designer tiles with contemporary patterns and unique textures for accent walls.', gallery: ['/images/tiles/coco-series/coco-000.png', '/images/tiles/coco-series/coco-001.png', '/images/tiles/coco-series/coco-003.png'] },
  { id: 'flute-series', name: 'Flute Series', size: 'Various', count: 49, description: '3D textured wall tiles creating stunning visual depth for feature walls.', gallery: ['/images/tiles/flute-series/flute-series-003.png', '/images/tiles/flute-series/flute-series-004.png'] },
  { id: 'golden-glossy', name: 'Golden Glossy', size: '600x1200 MM', count: 15, description: 'Glazed Vitrified Tiles (GVT) & Polished Glazed Vitrified Tiles (PGVT) 600x1200mm. Spaces that come to life and designs that turn your doubts into decisions. Manufacturer of high-end product range of premium tiles.', gallery: ['/images/tiles/golden-glossy/gg-image-1.png', '/images/tiles/golden-glossy/gg-image-4.png', '/images/tiles/golden-glossy/gg-image-2.png'] },
  { id: 'master', name: 'Master Collection', size: 'Various', count: 20, description: 'Our flagship premium tile range featuring the finest designs.', comingSoon: true, gallery: ['/images/tiles/master/master-001.png', '/images/tiles/master/master-002.png', '/images/tiles/master/master-003.png', '/images/tiles/master/master-004.png', '/images/tiles/master/master-005.png'] },
  { id: 'pool-mosaics', name: 'Pool Mosaics', size: 'Various', count: 9, description: 'Durable mosaic tiles for swimming pools. Matt finish, chlorine resistant.', gallery: ['/images/tiles/pool-mosaics/gallery-01.png', '/images/tiles/pool-mosaics/gallery-02.png', '/images/tiles/pool-mosaics/technical-features.png'] },
  { id: 'sparten', name: 'Sparten Collection', size: '1200x1800 MM', count: 18, description: 'Extra-large glossy format porcelain slabs for seamless luxury surfaces.', comingSoon: true, gallery: ['/images/tiles/sparten/sparten-013.png'] },
  { id: 'subway', name: 'Subway Tiles', size: '65x260 MM', count: 32, description: 'Classic subway tiles for timeless kitchen and bathroom designs.', gallery: ['/images/tiles/subway/smoke-collection/inspiration-1.png', '/images/tiles/subway65-008.png', '/images/tiles/subway/smoke-collection/inspiration-4.png', '/images/tiles/subway-pente/gallery-1.png', '/images/tiles/subway-pente/gallery-2.png'] },
  { id: 'swimming-pool', name: 'Swimming Pool', size: 'Various', count: 20, description: 'Ideal for various styles and sizes, these surfaces are perfect for any kind and any size of swimming pool.', gallery: ['/images/tiles/swimming-pool/pool-001.png', '/images/tiles/swimming-pool/pool-002.png', '/images/tiles/swimming-pool/pool-003.png'] },
];

const bankSeriesProducts = [
  { name: 'MID NIGHT', finish: 'GLOSSY', thickness: '10.5 MM', images: ['/images/tiles/bank-series/bank-004.png', '/images/tiles/bank-series/bank-005.png', '/images/tiles/bank-series/bank-006.png'] },
  { name: 'GOLD', finish: 'GLOSSY', thickness: '10.5 MM', images: ['/images/tiles/bank-series/bank-007.png', '/images/tiles/bank-series/bank-008.png', '/images/tiles/bank-series/bank-009.png'] },
  { name: 'LILAC', finish: 'GLOSSY', thickness: '10.5 MM', images: ['/images/tiles/bank-series/bank-010.png', '/images/tiles/bank-series/bank-011.png', '/images/tiles/bank-series/bank-012.png'] },
  { name: 'SMOKE GREY', finish: 'GLOSSY', thickness: '10.5 MM', images: ['/images/tiles/bank-series/bank-013.png', '/images/tiles/bank-series/bank-014.png', '/images/tiles/bank-series/bank-015.png'] },
  { name: 'STORM', finish: 'GLOSSY', thickness: '10.5 MM', images: ['/images/tiles/bank-series/bank-016.png', '/images/tiles/bank-series/bank-017.png', '/images/tiles/bank-series/bank-018.png'] },
  { name: 'EARTH', finish: 'GLOSSY', thickness: '10.5 MM', images: ['/images/tiles/bank-series/bank-019.png', '/images/tiles/bank-series/bank-020.png', '/images/tiles/bank-series/bank-021.png'] },
  { name: 'MAGNET', finish: 'GLOSSY', thickness: '10.5 MM', images: ['/images/tiles/bank-series/bank-series-023.png', '/images/tiles/bank-series/bank-series-024.png', '/images/tiles/bank-series/bank-series-025.png'] },
  { name: 'MAIZE', finish: 'GLOSSY', thickness: '10.5 MM', images: ['/images/tiles/bank-series/bank-series-026.png', '/images/tiles/bank-series/bank-series-027.png', '/images/tiles/bank-series/bank-series-028.png'] },
  { name: 'SALT', finish: 'GLOSSY', thickness: '10.5 MM', images: ['/images/tiles/bank-series/bank-series-029.png', '/images/tiles/bank-series/bank-series-030.png', '/images/tiles/bank-series/bank-series-031.png'] },
];

const cocoSeriesProducts = [
  { name: 'MAIZE', finish: 'MATT', thickness: '10 MM', size: '65x260 MM', images: ['/images/tiles/coco-series/coco-005.png', '/images/tiles/coco-series/coco-004.png', '/images/tiles/coco-series/coco-006.png'] },
  { name: 'MAGNET', finish: 'MATT', thickness: '10 MM', size: '65x260 MM', images: ['/images/tiles/coco-series/coco-008.png', '/images/tiles/coco-series/coco-007.png', '/images/tiles/coco-series/coco-009.png'] },
  { name: 'SAGE', finish: 'MATT', thickness: '10 MM', size: '65x260 MM', images: ['/images/tiles/coco-series/coco-011.png', '/images/tiles/coco-series/coco-010.png', '/images/tiles/coco-series/coco-012.png'] },
  { name: 'MID NIGHT', finish: 'GLOSSY', thickness: '10 MM', size: '65x260 MM', images: ['/images/tiles/coco-series/coco-014.png', '/images/tiles/coco-series/coco-013.png', '/images/tiles/coco-series/coco-015.png'] },
  { name: 'SALT', finish: 'MATT', thickness: '10 MM', size: '65x260 MM', images: ['/images/tiles/coco-series/coco-017.png', '/images/tiles/coco-series/coco-016.png', '/images/tiles/coco-series/coco-018.png'] },
];

const fluteSeriesProducts = [
  { name: 'BRICK RED', subSection: 'FRENDI', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-011.png'] },
  { name: 'WHITE', subSection: 'FRENDI', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-012.png'] },
  { name: 'CARAMEL', subSection: 'FRENDI', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-013.png'] },
  { name: 'PINK', subSection: 'FRENDI', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-014.png'] },
  { name: 'DARK GREY', subSection: 'FRENDI', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-015.png'] },
  { name: 'NAVY BLUE', subSection: 'FRENDI', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-016.png'] },
  { name: 'BEIGE', subSection: 'FRENDI', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-017.png'] },
  { name: 'VERMILION', subSection: 'FRENDI', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-018.png'] },
  { name: 'DARK GREEN', subSection: 'FRENDI', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-019.png'] },
  { name: 'PICKLE GREEN', subSection: 'FRENDI', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-020.png'] },
  { name: 'LIGHT GREEN', subSection: 'FRENDI', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-021.png'] },
  { name: 'BLACK', subSection: 'FRENDI', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-022.png'] },
  { name: 'COBALT BLUE', subSection: 'FRENDI', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-024.png'] },
  { name: 'OCRA YELLOW', subSection: 'FRENDI', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-025.png'] },
  { name: 'CARAMEL', subSection: 'RIBBED', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-027.png'] },
  { name: 'BRICK RED', subSection: 'RIBBED', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-028.png'] },
  { name: 'COBALT BLUE', subSection: 'RIBBED', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-029.png'] },
  { name: 'DARK GREY', subSection: 'RIBBED', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-030.png'] },
  { name: 'DARK GREEN', subSection: 'RIBBED', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-031.png'] },
  { name: 'PICKLE GREEN', subSection: 'RIBBED', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-032.png'] },
  { name: 'LIGHT GREEN', subSection: 'RIBBED', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-033.png'] },
  { name: 'NAVY BLUE', subSection: 'RIBBED', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-034.png'] },
  { name: 'OCRA YELLOW', subSection: 'RIBBED', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-035.png'] },
  { name: 'WHITE', subSection: 'RIBBED', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-036.png'] },
  { name: 'PINK', subSection: 'RIBBED', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-037.png'] },
  { name: 'VERMILION', subSection: 'RIBBED', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-038.png'] },
  { name: 'DARK GREEN', subSection: 'TRON', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-043.png'] },
  { name: 'DARK GREY', subSection: 'TRON', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-044.png'] },
  { name: 'COBALT BLUE', subSection: 'TRON', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-045.png'] },
  { name: 'NAVY BLUE', subSection: 'TRON', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-046.png'] },
  { name: 'CARAMEL', subSection: 'TRON', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-047.png'] },
  { name: 'OCRA YELLOW', subSection: 'TRON', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-048.png'] },
  { name: 'PINK', subSection: 'TRON', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-049.png'] },
  { name: 'VERMILION', subSection: 'TRON', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-050.png'] },
  { name: 'BEIGE', subSection: 'TRON', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-051.png'] },
  { name: 'BRICK RED', subSection: 'TRON', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-052.png'] },
  { name: 'PEWTER', subSection: 'TRON', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-053.png'] },
  { name: 'BLACK', subSection: 'WENDO', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-058.png'] },
  { name: 'PINK', subSection: 'WENDO', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-059.png'] },
  { name: 'BRICK RED', subSection: 'WENDO', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-060.png'] },
  { name: 'NAVY BLUE', subSection: 'WENDO', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-061.png'] },
  { name: 'COBALT BLUE', subSection: 'WENDO', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-062.png'] },
  { name: 'OCRA YELLOW', subSection: 'WENDO', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-063.png'] },
  { name: 'DARK GREY', subSection: 'WENDO', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-064.png'] },
  { name: 'VERMILION', subSection: 'WENDO', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-065.png'] },
  { name: 'PEWTER', subSection: 'WENDO', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-066.png'] },
  { name: 'OBSIDIAN', subSection: 'WENDO', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-067.png'] },
  { name: 'DARK GREEN', subSection: 'WENDO', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-068.png'] },
  { name: 'LIGHT GREEN', subSection: 'WENDO', size: '75x300 MM', finish: 'MATTE', images: ['/images/tiles/flute-series/flute-series-069.png'] },
];

const ggImg = (n) => `/images/tiles/golden-glossy/gg-image-${n}.png`;

const goldenGlossyApplicationAreas = [
  { name: 'Residential', icon: 'Home' },
  { name: 'Commercial Building', icon: 'Building2' },
  { name: 'Hotel, Restaurant & Cafe', icon: 'UtensilsCrossed' },
  { name: 'Gymnasium', icon: 'Dumbbell' },
  { name: 'Hall & Corridor', icon: 'DoorOpen' },
  { name: 'Mall & Super Market', icon: 'ShoppingCart' },
  { name: 'Hospital', icon: 'Cross' },
  { name: 'Airport', icon: 'Plane' },
  { name: 'School & College', icon: 'GraduationCap' },
  { name: 'Industry', icon: 'Factory' },
  { name: 'Spa & Wellness Centres', icon: 'Flower2' },
  { name: 'Religious Place', icon: 'Church' },
];

const goldenGlossyTechSpecs = [
  { name: 'Long Durability', icon: 'Timer' },
  { name: 'Easy to Clean', icon: 'Sparkles' },
  { name: 'Impact Resistance', icon: 'Shield' },
  { name: 'Frost Resistance', icon: 'Snowflake' },
  { name: 'Low Water Absorption', icon: 'Droplets' },
  { name: 'Dimensional Stability', icon: 'Ruler' },
  { name: 'Hygienic Surface', icon: 'HeartPulse' },
  { name: 'Fire Resistance', icon: 'Flame' },
  { name: 'Chemical Resistance', icon: 'FlaskConical' },
  { name: 'Easy Installation', icon: 'Wrench' },
  { name: 'Thermal Shock Resistance', icon: 'Thermometer' },
  { name: 'Crazing Resistance', icon: 'ShieldCheck' },
];

const goldenGlossyProducts = [
  { name: 'DAZZY WHITE', finish: 'ENDLESS', random: '3', images: [ggImg(8), ggImg(5), ggImg(6), ggImg(7)], applicationAreas: goldenGlossyApplicationAreas, techSpecs: goldenGlossyTechSpecs },
  { name: 'ENTRIA GREY', finish: 'ENDLESS', random: '4', images: [ggImg(9), ggImg(10), ggImg(11)], applicationAreas: goldenGlossyApplicationAreas, techSpecs: goldenGlossyTechSpecs },
  { name: 'EQUADOR BLUE', finish: 'ENDLESS', random: '2', images: [ggImg(12), ggImg(13), ggImg(14), ggImg(15)], applicationAreas: goldenGlossyApplicationAreas, techSpecs: goldenGlossyTechSpecs },
  { name: 'FLUID BLACK', finish: 'ENDLESS', random: '2', images: [ggImg(16), ggImg(17), ggImg(18)], applicationAreas: goldenGlossyApplicationAreas, techSpecs: goldenGlossyTechSpecs },
  { name: 'FURIANO ALLOY', finish: 'ENDLESS', random: '3', images: [ggImg(19), ggImg(20), ggImg(21)], applicationAreas: goldenGlossyApplicationAreas, techSpecs: goldenGlossyTechSpecs },
  { name: 'GLAMORA METAL', finish: 'ENDLESS', random: '2', images: [ggImg(22), ggImg(23), ggImg(24), ggImg(25)], applicationAreas: goldenGlossyApplicationAreas, techSpecs: goldenGlossyTechSpecs },
  { name: 'HENLY GLOD', finish: 'ENDLESS', random: '2', images: [ggImg(26), ggImg(27), ggImg(28)], applicationAreas: goldenGlossyApplicationAreas, techSpecs: goldenGlossyTechSpecs },
  { name: 'JASPER WHITE', finish: 'ENDLESS', random: '3', images: [ggImg(29), ggImg(30), ggImg(31)], applicationAreas: goldenGlossyApplicationAreas, techSpecs: goldenGlossyTechSpecs },
  { name: 'JIZZE WHITE', finish: 'ENDLESS', random: '3', images: [ggImg(32), ggImg(33), ggImg(34), ggImg(35)], applicationAreas: goldenGlossyApplicationAreas, techSpecs: goldenGlossyTechSpecs },
  { name: 'KOSHI BLANCO', finish: 'ENDLESS', random: '2', images: [ggImg(36), ggImg(37), ggImg(38)], applicationAreas: goldenGlossyApplicationAreas, techSpecs: goldenGlossyTechSpecs },
  { name: 'LEORENT GLOD', finish: 'ENDLESS', random: '2', images: [ggImg(39), ggImg(40), ggImg(41)], applicationAreas: goldenGlossyApplicationAreas, techSpecs: goldenGlossyTechSpecs },
  { name: 'MISHOL GREY', finish: 'ENDLESS', random: '2', images: [ggImg(42), ggImg(43), ggImg(44), ggImg(45)], applicationAreas: goldenGlossyApplicationAreas, techSpecs: goldenGlossyTechSpecs },
  { name: 'PESARA GLOD', finish: 'ENDLESS', random: '2', images: [ggImg(46), ggImg(47), ggImg(48)], applicationAreas: goldenGlossyApplicationAreas, techSpecs: goldenGlossyTechSpecs },
  { name: 'SAYLOR GOLDEN', finish: 'ENDLESS', random: '2', images: [ggImg(49), ggImg(50), ggImg(51)], applicationAreas: goldenGlossyApplicationAreas, techSpecs: goldenGlossyTechSpecs },
  { name: 'VELMO SLEEK', finish: 'ENDLESS', random: '2', images: [ggImg(52), ggImg(53), ggImg(54), ggImg(55)], applicationAreas: goldenGlossyApplicationAreas, techSpecs: goldenGlossyTechSpecs },
];

const masterProducts = [
  { name: 'ROYAL HERITAGE', finish: 'PREMIUM', thickness: '10 MM', imageIdx: [1] },
  { name: 'IMPERIAL PALACE', finish: 'PREMIUM', thickness: '10 MM', imageIdx: [2] },
  { name: 'GRAND VERSAILLES', finish: 'PREMIUM', thickness: '10 MM', imageIdx: [3] },
  { name: 'TUSCAN VILLA', finish: 'PREMIUM', thickness: '10 MM', imageIdx: [4] },
  { name: 'MEDITERRANEAN SEA', finish: 'PREMIUM', thickness: '10 MM', imageIdx: [5] },
  { name: 'BYZANTINE GOLD', finish: 'PREMIUM', thickness: '10 MM', imageIdx: [6] },
  { name: 'RENAISSANCE ART', finish: 'PREMIUM', thickness: '10 MM', imageIdx: [7] },
  { name: 'BAROQUE LUXURY', finish: 'PREMIUM', thickness: '10 MM', imageIdx: [8] },
  { name: 'VICTORIAN CHARM', finish: 'PREMIUM', thickness: '10 MM', imageIdx: [9] },
  { name: 'ART DECO CLASSIC', finish: 'PREMIUM', thickness: '10 MM', imageIdx: [10] },
  { name: 'MODERN LUXE', finish: 'PREMIUM', thickness: '10 MM', imageIdx: [11] },
  { name: 'URBAN CHIC', finish: 'PREMIUM', thickness: '10 MM', imageIdx: [12] },
  { name: 'COASTAL LIVING', finish: 'PREMIUM', thickness: '10 MM', imageIdx: [13] },
  { name: 'MOUNTAIN LODGE', finish: 'PREMIUM', thickness: '10 MM', imageIdx: [14] },
  { name: 'SAFARI STONE', finish: 'PREMIUM', thickness: '10 MM', imageIdx: [15] },
  { name: 'ORIENTAL SILK', finish: 'PREMIUM', thickness: '10 MM', imageIdx: [16] },
  { name: 'NORDIC FROST', finish: 'PREMIUM', thickness: '10 MM', imageIdx: [17] },
  { name: 'TROPICAL PARADISE', finish: 'PREMIUM', thickness: '10 MM', imageIdx: [18] },
  { name: 'DESERT OASIS', finish: 'PREMIUM', thickness: '10 MM', imageIdx: [19] },
  { name: 'FOREST RETREAT', finish: 'PREMIUM', thickness: '10 MM', imageIdx: [20] },
];

const pmImg = (n) => `/images/tiles/pool-mosaics/image-${String(n).padStart(2, '0')}.png`;

const poolMosaicsTechnicalFeatures = [
  { name: 'Frost Resistance', icon: 'Snowflake' },
  { name: 'Resistance Load & Stress', icon: 'Shield' },
  { name: 'Chemical Resistance', icon: 'FlaskConical' },
  { name: 'Environment Friendly', icon: 'Leaf' },
  { name: 'Fire Resistance', icon: 'Flame' },
  { name: 'Corrosion Resistance', icon: 'ShieldCheck' },
  { name: 'Heat Resistant', icon: 'Thermometer' },
  { name: 'Scratch Resistant', icon: 'ShieldAlert' },
];

const poolMosaicsVariations = [
  { name: 'Very Uniform Appearance', icon: 'square', level: 1 },
  { name: 'Uniform Appearance', icon: 'square', level: 2 },
  { name: 'Moderate Variation', icon: 'square', level: 3 },
  { name: 'Substantial Variation', icon: 'square', level: 4 },
];

const poolMosaicsSizeVariants = [
  { chipSize: '48x48mm', sheetSize: '303x303mm', thickness: '6mm' },
  { chipSize: '73x73mm', sheetSize: '303x303mm', thickness: '8mm' },
  { chipSize: '98x98mm', sheetSize: '306x306mm', thickness: '8mm' },
];

const poolMosaicsProducts = [
  {
    name: 'PIETRO',
    finish: 'MATT',
    images: [pmImg(1), pmImg(15), pmImg(10), pmImg(11), pmImg(12), pmImg(13), pmImg(14)],
    imageLabels: [null, null, 'PIETRO AZUL', 'PIETRO GLAM', null, null, null],
    sizeVariants: poolMosaicsSizeVariants,
    variations: poolMosaicsVariations,
    technicalFeatures: poolMosaicsTechnicalFeatures,
  },
  {
    name: 'EARTH BLUE',
    finish: 'MATT',
    images: [pmImg(2), pmImg(16), pmImg(20), pmImg(21), pmImg(17), pmImg(18), pmImg(19)],
    imageLabels: [null, null, null, null, '98x98mm | Sheet: 306x306mm | 8mm', '73x73mm | Sheet: 303x303mm | 8mm', '48x48mm | Sheet: 303x303mm | 6mm'],
    sizeVariants: poolMosaicsSizeVariants,
    variations: poolMosaicsVariations,
    technicalFeatures: poolMosaicsTechnicalFeatures,
  },
  {
    name: 'EARTH GREEN',
    finish: 'MATT',
    images: [pmImg(3), pmImg(22), pmImg(23), pmImg(24), pmImg(25), pmImg(26), pmImg(27), pmImg(28)],
    imageLabels: [null, null, null, null, '98x98mm | Sheet: 306x306mm | 8mm', '73x73mm | Sheet: 303x303mm | 8mm', '48x48mm | Sheet: 303x303mm | 6mm', null],
    sizeVariants: poolMosaicsSizeVariants,
    variations: poolMosaicsVariations,
    technicalFeatures: poolMosaicsTechnicalFeatures,
  },
  {
    name: 'EMERALD GREEN',
    finish: 'MATT',
    images: [pmImg(4), pmImg(29), pmImg(30), pmImg(31), pmImg(32), pmImg(33), pmImg(34), pmImg(35)],
    imageLabels: [null, null, null, null, '98x98mm | Sheet: 306x306mm | 8mm', '73x73mm | Sheet: 303x303mm | 8mm', '48x48mm | Sheet: 303x303mm | 6mm', null],
    sizeVariants: poolMosaicsSizeVariants,
    variations: poolMosaicsVariations,
    technicalFeatures: poolMosaicsTechnicalFeatures,
  },
  {
    name: 'SPOTO',
    finish: 'GLOSSY',
    images: [pmImg(5), pmImg(36), pmImg(37), pmImg(38), pmImg(39), pmImg(40), pmImg(41), pmImg(42)],
    imageLabels: [null, null, null, null, '98x98mm | Sheet: 306x306mm | 8mm', '73x73mm | Sheet: 303x303mm | 8mm', '48x48mm | Sheet: 303x303mm | 6mm', null],
    sizeVariants: poolMosaicsSizeVariants,
    variations: poolMosaicsVariations,
    technicalFeatures: poolMosaicsTechnicalFeatures,
  },
  {
    name: 'SPOTO 3',
    finish: 'GLOSSY',
    images: [pmImg(6), pmImg(43), pmImg(44), pmImg(45), pmImg(46), pmImg(47)],
    imageLabels: [null, null, null, null, '98x98mm | Sheet: 306x306mm | 8mm', null],
    sizeVariants: poolMosaicsSizeVariants,
    variations: poolMosaicsVariations,
    technicalFeatures: poolMosaicsTechnicalFeatures,
  },
  {
    name: 'MERAKI NILE BLUE',
    finish: 'MATT',
    images: [pmImg(7), pmImg(48), pmImg(49), pmImg(50), pmImg(51), pmImg(52), pmImg(53)],
    imageLabels: [null, null, null, null, '98x98mm | Sheet: 306x306mm | 8mm', '73x73mm | Sheet: 303x303mm | 8mm', null],
    sizeVariants: poolMosaicsSizeVariants,
    variations: poolMosaicsVariations,
    technicalFeatures: poolMosaicsTechnicalFeatures,
  },
  {
    name: 'SAPPHIRE GREEN',
    finish: 'MATT',
    images: [pmImg(8), pmImg(54), pmImg(55), pmImg(56), pmImg(57), pmImg(58), pmImg(59), pmImg(60)],
    imageLabels: [null, null, null, null, '98x98mm | Sheet: 306x306mm | 8mm', '73x73mm | Sheet: 303x303mm | 8mm', '48x48mm | Sheet: 303x303mm | 6mm', null],
    sizeVariants: poolMosaicsSizeVariants,
    variations: poolMosaicsVariations,
    technicalFeatures: poolMosaicsTechnicalFeatures,
  },
  {
    name: 'SONET BLUE',
    finish: 'MATT',
    images: [pmImg(9), pmImg(61), pmImg(62), pmImg(63), pmImg(64), pmImg(65), pmImg(66)],
    imageLabels: [null, null, null, null, '98x98mm | Sheet: 306x306mm | 8mm', '73x73mm | Sheet: 303x303mm | 8mm', null],
    sizeVariants: poolMosaicsSizeVariants,
    variations: poolMosaicsVariations,
    technicalFeatures: poolMosaicsTechnicalFeatures,
  },
];

const spartenProducts = [
  { name: 'DIKE OVIO ENDLESS', finish: 'GLOSSY SURFACE', random: '03', imageIdx: [1, 19] },
  { name: 'DOVER CREMA ENDLESS', finish: 'GLOSSY SURFACE', random: '03', imageIdx: [2, 20] },
  { name: 'DOVER GREY ENDLESS', finish: 'GLOSSY SURFACE', random: '03', imageIdx: [3, 21] },
  { name: 'DOVER TAUPE ENDLESS', finish: 'GLOSSY SURFACE', random: '03', imageIdx: [4, 22] },
  { name: 'EPROSS GREY ENDLESS', finish: 'GLOSSY SURFACE', random: '03', imageIdx: [5, 23] },
  { name: 'EPROSS BEIGE ENDLESS', finish: 'GLOSSY SURFACE', random: '03', imageIdx: [6, 24] },
  { name: 'EPROSS BIANCO ENDLESS', finish: 'GLOSSY SURFACE', random: '03', imageIdx: [7, 25] },
  { name: 'EPROSS BROWN ENDLESS', finish: 'GLOSSY SURFACE', random: '03', imageIdx: [8, 26] },
  { name: 'FENIX GREY ENDLESS', finish: 'GLOSSY SURFACE', random: '03', imageIdx: [9, 27] },
  { name: 'FENIX BEIGE ENDLESS', finish: 'GLOSSY SURFACE', random: '03', imageIdx: [10, 28] },
  { name: 'FENIX BIANCO ENDLESS', finish: 'GLOSSY SURFACE', random: '03', imageIdx: [4, 29] },
  { name: 'FENIX BROWN ENDLESS', finish: 'GLOSSY SURFACE', random: '03', imageIdx: [5, 30] },
  { name: 'VICTORIA WHITE ENDLESS', finish: 'GLOSSY SURFACE', random: '03', imageIdx: [13, 31] },
  { name: 'VICTORIA GREY ENDLESS', finish: 'GLOSSY SURFACE', random: '03', imageIdx: [5, 32] },
  { name: 'ZENITH GIRGIO ENDLESS', finish: 'GLOSSY SURFACE', random: '03', imageIdx: [15, 33] },
  { name: 'ZENITH BEIGE ENDLESS', finish: 'GLOSSY SURFACE', random: '03', imageIdx: [16, 34] },
  { name: 'ZENITH BIANCO ENDLESS', finish: 'GLOSSY SURFACE', random: '03', imageIdx: [17, 35] },
  { name: 'ZENITH BROWN ENDLESS', finish: 'GLOSSY SURFACE', random: '03', imageIdx: [18, 36] },
];

const subwayProducts = [
  { name: 'SMOKE ROSE', subSection: 'SMOKE COLLECTION', finish: 'GLOSSY', thickness: '8.5 MM', images: ['/images/tiles/subway/smoke-collection/smoke-rose-1.png', '/images/tiles/subway/smoke-collection/smoke-rose-2.png'] },
  { name: 'SMOKE BIANCO', subSection: 'SMOKE COLLECTION', finish: 'GLOSSY', thickness: '8.5 MM', images: ['/images/tiles/subway/smoke-collection/smoke-bianco-1.png', '/images/tiles/subway/smoke-collection/smoke-bianco-2.png'] },
  { name: 'SMOKE LEAF', subSection: 'SMOKE COLLECTION', finish: 'GLOSSY', thickness: '8.5 MM', images: ['/images/tiles/subway/smoke-collection/smoke-leaf-1.png', '/images/tiles/subway/smoke-collection/smoke-leaf-2.png'] },
  { name: 'SMOKE OCEAN', subSection: 'SMOKE COLLECTION', finish: 'GLOSSY', thickness: '8.5 MM', images: ['/images/tiles/subway/smoke-collection/smoke-ocean-1.png', '/images/tiles/subway/smoke-collection/smoke-ocean-2.png'] },
  { name: 'SMOKE ASH', subSection: 'SMOKE COLLECTION', finish: 'GLOSSY', thickness: '8.5 MM', images: ['/images/tiles/subway/smoke-collection/smoke-ash-1.png', '/images/tiles/subway/smoke-collection/smoke-ash-2.png'] },
  { name: 'SMOKE COPPER', subSection: 'SMOKE COLLECTION', finish: 'GLOSSY', thickness: '8.5 MM', images: ['/images/tiles/subway/smoke-collection/smoke-copper-1.png', '/images/tiles/subway/smoke-collection/smoke-copper-2.png'] },
  { name: 'BLOOSOM', subSection: 'PENTE COLLECTION', finish: 'GLOSSY', thickness: '8.5 MM', images: ['/images/tiles/subway-pente/bloosom-1.png', '/images/tiles/subway-pente/bloosom-2.png'] },
  { name: 'COTTO', subSection: 'PENTE COLLECTION', finish: 'GLOSSY', thickness: '8.5 MM', images: ['/images/tiles/subway-pente/cotto-1.png', '/images/tiles/subway-pente/cotto-2.png'] },
  { name: 'DOVE', subSection: 'PENTE COLLECTION', finish: 'GLOSSY', thickness: '8.5 MM', images: ['/images/tiles/subway-pente/dove-1.png', '/images/tiles/subway-pente/dove-2.png'] },
  { name: 'FOREST', subSection: 'PENTE COLLECTION', finish: 'GLOSSY', thickness: '8.5 MM', images: ['/images/tiles/subway-pente/forest-1.png', '/images/tiles/subway-pente/forest-2.png'] },
  { name: 'GRIS', subSection: 'PENTE COLLECTION', finish: 'GLOSSY', thickness: '8.5 MM', images: ['/images/tiles/subway-pente/gris-1.png', '/images/tiles/subway-pente/gris-2.png'] },
  { name: 'LINEN', subSection: 'PENTE COLLECTION', finish: 'GLOSSY', thickness: '8.5 MM', images: ['/images/tiles/subway-pente/linen-1.png', '/images/tiles/subway-pente/linen-2.png'] },
  { name: 'SEA', subSection: 'PENTE COLLECTION', finish: 'GLOSSY', thickness: '8.5 MM', images: ['/images/tiles/subway-pente/sea-1.png', '/images/tiles/subway-pente/sea-2.png'] },
  { name: 'TEAL', subSection: 'PENTE COLLECTION', finish: 'GLOSSY', thickness: '8.5 MM', images: ['/images/tiles/subway-pente/teal-1.png', '/images/tiles/subway-pente/teal-2.png'] },
  { name: 'SUBWAY CLASSIC WHITE', finish: 'GLOSSY', thickness: '8 MM', imageIdx: [0] },
  { name: 'SUBWAY METRO GREY', finish: 'GLOSSY', thickness: '8 MM', imageIdx: [1] },
  { name: 'SUBWAY URBAN BLACK', finish: 'GLOSSY', thickness: '8 MM', imageIdx: [2] },
  { name: 'SUBWAY VINTAGE CREAM', finish: 'GLOSSY', thickness: '8 MM', imageIdx: [3] },
  { name: 'SUBWAY RETRO GREEN', finish: 'GLOSSY', thickness: '8 MM', imageIdx: [4] },
  { name: 'SUBWAY INDUSTRIAL BLUE', finish: 'GLOSSY', thickness: '8 MM', imageIdx: [5] },
  { name: 'SUBWAY RUSTIC BROWN', finish: 'GLOSSY', thickness: '8 MM', imageIdx: [6] },
  { name: 'SUBWAY MODERN MINT', finish: 'GLOSSY', thickness: '8 MM', imageIdx: [7] },
  { name: 'SUBWAY CHIC PINK', finish: 'GLOSSY', thickness: '8 MM', imageIdx: [8] },
  { name: 'SUBWAY BOLD RED', finish: 'GLOSSY', thickness: '8 MM', imageIdx: [9] },
  { name: 'SUBWAY SUNNY YELLOW', finish: 'GLOSSY', thickness: '8 MM', imageIdx: [10] },
  { name: 'SUBWAY OCEAN TEAL', finish: 'GLOSSY', thickness: '8 MM', imageIdx: [11] },
  { name: 'SUBWAY FOREST MOSS', finish: 'GLOSSY', thickness: '8 MM', imageIdx: [12] },
  { name: 'SUBWAY DESERT SAND', finish: 'GLOSSY', thickness: '8 MM', imageIdx: [13] },
  { name: 'SUBWAY MOUNTAIN STONE', finish: 'GLOSSY', thickness: '8 MM', imageIdx: [14] },
  { name: 'SUBWAY RIVER PEBBLE', finish: 'GLOSSY', thickness: '8 MM', imageIdx: [15] },
  { name: 'SUBWAY CLOUD WHITE', finish: 'GLOSSY', thickness: '8 MM', imageIdx: [16] },
  { name: 'SUBWAY FOG GREY', finish: 'GLOSSY', thickness: '8 MM', imageIdx: [17] },
];

const subwayPenteProducts = [];

const swimmingPoolProducts = [
  {
    name: 'G/M 0101, 0102, 0103',
    finish: 'GLOSSY/MATT',
    size: '23x23 MM',
    images: ['/images/tiles/swimming-pool/pool-004.png', '/images/tiles/swimming-pool/pool-005.png'],
    description: 'Ideal for various styles and sizes, these surfaces are perfect for any kind and any size of swimming pool'
  },
  {
    name: 'G/M 0110, 0111, 0112',
    finish: 'GLOSSY/MATT',
    size: '23x23 MM',
    images: ['/images/tiles/swimming-pool/pool-006.png', '/images/tiles/swimming-pool/pool-007.png'],
    description: 'Ideal for various styles and sizes, these surfaces are perfect for any kind and any size of swimming pool'
  },
  {
    name: 'CLD0201, CLD0202, CLD0203, CLD0204',
    finish: 'GLOSSY',
    size: '48x48 MM',
    surface: 'CLOUDY',
    images: ['/images/tiles/swimming-pool/pool-008.png', '/images/tiles/swimming-pool/pool-009.png'],
    description: 'Ideal for various styles and sizes, these surfaces are perfect for any kind and any size of swimming pool'
  },
  {
    name: 'CLD0205, CLD0206, CLD0207, CLD0208',
    finish: 'GLOSSY',
    size: '48x48 MM',
    surface: 'CLOUDY',
    images: ['/images/tiles/swimming-pool/pool-010.png', '/images/tiles/swimming-pool/pool-011.png'],
    description: 'Ideal for various styles and sizes, these surfaces are perfect for any kind and any size of swimming pool'
  },
  {
    name: 'CR0204, CR0206, CR0207',
    finish: 'GLOSSY',
    size: '48x48 MM',
    surface: 'CRACKLE',
    images: ['/images/tiles/swimming-pool/pool-012.png', '/images/tiles/swimming-pool/pool-013.png'],
    description: 'Ideal for various styles and sizes, these surfaces are perfect for any kind and any size of swimming pool'
  },
  {
    name: 'CR0211, CR0212, CR0214',
    finish: 'GLOSSY',
    size: '48x48 MM',
    surface: 'CRACKLE',
    images: ['/images/tiles/swimming-pool/pool-014.png', '/images/tiles/swimming-pool/pool-015.png'],
    description: 'Ideal for various styles and sizes, these surfaces are perfect for any kind and any size of swimming pool'
  },
  {
    name: 'CR0215, CR0221, CR0253, G/M 0219',
    finish: 'GLOSSY',
    size: '48x48 MM',
    surface: 'CRACKLE',
    images: ['/images/tiles/swimming-pool/pool-016.png', '/images/tiles/swimming-pool/pool-017.png'],
    description: 'Ideal for various styles and sizes, these surfaces are perfect for any kind and any size of swimming pool'
  },
  {
    name: 'G/M 0201, 0202, 0203',
    finish: 'GLOSSY/MATT',
    size: '48x48 MM',
    images: ['/images/tiles/swimming-pool/pool-018.png', '/images/tiles/swimming-pool/pool-019.png'],
    description: 'Ideal for various styles and sizes, these surfaces are perfect for any kind and any size of swimming pool'
  },
  {
    name: 'G/M 0204, 0205, 0206',
    finish: 'GLOSSY/MATT',
    size: '48x48 MM',
    images: ['/images/tiles/swimming-pool/pool-020.png', '/images/tiles/swimming-pool/pool-021.png'],
    description: 'Ideal for various styles and sizes, these surfaces are perfect for any kind and any size of swimming pool'
  },
  {
    name: 'G/M 0207, 0208, 0209',
    finish: 'GLOSSY/MATT',
    size: '48x48 MM',
    images: ['/images/tiles/swimming-pool/pool-022.png', '/images/tiles/swimming-pool/pool-023.png'],
    description: 'Ideal for various styles and sizes, these surfaces are perfect for any kind and any size of swimming pool'
  },
  {
    name: 'G/M 0210, 0211, 0212',
    finish: 'GLOSSY/MATT',
    size: '48x48 MM',
    images: ['/images/tiles/swimming-pool/pool-024.png', '/images/tiles/swimming-pool/pool-025.png'],
    description: 'Ideal for various styles and sizes, these surfaces are perfect for any kind and any size of swimming pool'
  },
  {
    name: 'G/M 0213, 0214, 0215',
    finish: 'GLOSSY/MATT',
    size: '48x48 MM',
    images: ['/images/tiles/swimming-pool/pool-026.png', '/images/tiles/swimming-pool/pool-027.png'],
    description: 'Ideal for various styles and sizes, these surfaces are perfect for any kind and any size of swimming pool'
  },
  {
    name: 'G/M 0216',
    finish: 'GLOSSY/MATT',
    size: '48x48 MM',
    images: ['/images/tiles/swimming-pool/pool-028.png', '/images/tiles/swimming-pool/pool-029.png'],
    description: 'Ideal for various styles and sizes, these surfaces are perfect for any kind and any size of swimming pool'
  },
  {
    name: 'G/M 0217, 0218, 0219',
    finish: 'GLOSSY/MATT',
    size: '48x48 MM',
    images: ['/images/tiles/swimming-pool/pool-030.png', '/images/tiles/swimming-pool/pool-031.png'],
    description: 'Ideal for various styles and sizes, these surfaces are perfect for any kind and any size of swimming pool'
  },
  {
    name: 'M 1901, M 1902',
    finish: 'MATT',
    size: '95x107 MM',
    images: ['/images/tiles/swimming-pool/pool-032.png', '/images/tiles/swimming-pool/pool-033.png'],
    description: 'Ideal for various styles and sizes, these surfaces are perfect for any kind and any size of swimming pool'
  },
  {
    name: 'M 1910, M 1911',
    finish: 'MATT',
    size: '95x107 MM',
    images: ['/images/tiles/swimming-pool/pool-034.png', '/images/tiles/swimming-pool/pool-035.png'],
    description: 'Ideal for various styles and sizes, these surfaces are perfect for any kind and any size of swimming pool'
  },
  {
    name: 'M 1913',
    finish: 'MATT',
    size: '95x107 MM',
    images: ['/images/tiles/swimming-pool/pool-036.png', '/images/tiles/swimming-pool/pool-037.png'],
    description: 'Ideal for various styles and sizes, these surfaces are perfect for any kind and any size of swimming pool'
  },
  {
    name: 'G/M 1915, 1916',
    finish: 'MATT',
    size: '95x107 MM',
    images: ['/images/tiles/swimming-pool/pool-038.png', '/images/tiles/swimming-pool/pool-039.png'],
    description: 'Ideal for various styles and sizes, these surfaces are perfect for any kind and any size of swimming pool'
  },
  {
    name: 'G/M 1701, 1702, 1703',
    finish: 'GLOSSY/MATT',
    size: '51x59 MM',
    images: ['/images/tiles/swimming-pool/pool-040.png', '/images/tiles/swimming-pool/pool-041.png'],
    description: 'Ideal for various styles and sizes, these surfaces are perfect for any kind and any size of swimming pool'
  },
  {
    name: 'G/M 1714, 1715, 1716',
    finish: 'GLOSSY/MATT',
    size: '51x59 MM',
    images: ['/images/tiles/swimming-pool/pool-042.png', '/images/tiles/swimming-pool/pool-043.png'],
    description: 'Ideal for various styles and sizes, these surfaces are perfect for any kind and any size of swimming pool'
  },
];

const descriptions = {
  'bank-series': 'Premium 100x300mm glossy wall tiles with 10.5mm thickness. High-quality ceramic with excellent durability and easy maintenance.',
  'coco-series': 'Designer tiles with contemporary patterns and textures. Ideal for creating unique accent walls and feature areas.',
  'flute-series': '3D textured wall tiles that add depth and dimension to any room. Perfect for creating stunning accent walls.',
  'golden-glossy': 'Luxurious 600x1200mm large format tiles with endless glossy finish. Premium porcelain for floors and walls.',
  'master': 'Our flagship collection featuring the finest tiles from around the world. Each piece is carefully selected for beauty and quality.',
  'pool-mosaics': 'Specially designed mosaic tiles for swimming pools and wet areas. Matt finish, slip-resistant, chlorine-resistant.',
  'sparten': 'Extra-large 1200x1800mm porcelain slabs with glossy surface for seamless, luxurious surfaces.',
  'subway': 'Classic 65x260mm subway tiles perfect for timeless kitchen and bathroom designs. Versatile and easy to clean.',
  'subway-pente': 'Premium Pente collection subway tiles with refined finishes and sophisticated color palette. European elegance.',
  'swimming-pool': 'Ideal for various styles and sizes, these surfaces are perfect for any kind and any size of swimming pool. GLOSSY/MATT finish available.'
};

const imageConfigs = {
  'bank-series': { folder: 'bank-series', prefix: 'bank-', total: 22 },
  'coco-series': { folder: 'coco-series', prefix: 'coco-', total: 19 },
  'flute-series': { folder: 'flute-series', prefix: 'flute-series-', total: 69 },
  'golden-glossy': { folder: 'golden-glossy', prefix: 'golden-glossy-', total: 128 },
  'master': { folder: 'master', prefix: 'master-', total: 21 },
  'pool-mosaics': { folder: 'pool-mosaics', prefix: 'image-', total: 66 },
  'sparten': { folder: 'sparten', prefix: 'sparten-', total: 36 },
  'subway': { folder: 'subway', prefix: 'subway65-', total: 18 },
  'subway-pente': { folder: 'subway-pente', prefix: 'subway-pente-', total: 74 },
  'swimming-pool': { folder: 'swimming-pool', prefix: 'pool-', total: 43 },
};

function generateProducts() {
  const products = [];
  let id = 1;
  
  const configs = [
    { category: 'bank-series', items: bankSeriesProducts, basePrice: 45, size: '100x300 MM' },
    { category: 'coco-series', items: cocoSeriesProducts, basePrice: 38, size: '65x260 MM' },
    { category: 'flute-series', items: fluteSeriesProducts, basePrice: 52, size: 'Various' },
    { category: 'golden-glossy', items: goldenGlossyProducts, basePrice: 85, size: '600x1200 MM' },
    { category: 'master', items: masterProducts, basePrice: 65, size: 'Various' },
    { category: 'pool-mosaics', items: poolMosaicsProducts, basePrice: 75, size: 'Various' },
    { category: 'sparten', items: spartenProducts, basePrice: 120, size: '1200x1800 MM' },
    { category: 'subway', items: subwayProducts, basePrice: 35, size: '65x260 MM' },
    { category: 'subway-pente', items: subwayPenteProducts, basePrice: 42, size: '65x260 MM' },
    { category: 'swimming-pool', items: swimmingPoolProducts, basePrice: 95, size: 'Various' },
  ];
  
  configs.forEach(config => {
    const categoryInfo = categories.find(c => c.id === config.category);
    const imgConfig = imageConfigs[config.category];
    
    config.items.forEach((item, i) => {
      const priceVariation = (i % 5) * 5;
      
      let images = [];
      
      if (item.images) {
        images = item.images;
      } else if (item.imageIdx) {
        images = item.imageIdx.map(idx => {
          const paddedIdx = String(idx).padStart(3, '0');
          return `/images/tiles/${imgConfig.folder}/${imgConfig.prefix}${paddedIdx}.png`;
        });
      } else {
        const paddedIdx = String(i + 1).padStart(3, '0');
        images = [`/images/tiles/${imgConfig.folder}/${imgConfig.prefix}${paddedIdx}.png`];
      }
      
      const productSize = item.size || config.size;
      let specs = `Size: ${productSize}`;
      if (item.finish) specs += ` | Finish: ${item.finish}`;
      if (item.surface) specs += ` | Surface: ${item.surface}`;
      if (item.thickness) specs += ` | Thickness: ${item.thickness}`;
      if (item.chipSize) specs += ` | Chip: ${item.chipSize}`;
      if (item.sheetSize) specs += ` | Sheet: ${item.sheetSize}`;
      if (item.random) specs += ` | Random: ${item.random}`;
      
      const productObj = {
        id: id++,
        name: item.name,
        category: config.category,
        categoryName: categoryInfo.name,
        subSection: item.subSection || '',
        size: productSize,
        finish: item.finish || item.surface || 'Standard',
        thickness: item.thickness || '',
        specs: specs,
        price: config.basePrice + priceVariation,
        priceUnit: 'per sqm',
        images: images,
        image: images[0],
        description: item.description || descriptions[config.category],
        inStock: true,
        features: [
          'Premium quality',
          'Easy maintenance',
          'Durable finish',
          'Suitable for indoor use'
        ]
      };
      if (item.sizeVariants) productObj.sizeVariants = item.sizeVariants;
      if (item.variations) productObj.variations = item.variations;
      if (item.technicalFeatures) productObj.technicalFeatures = item.technicalFeatures;
      if (item.subTypes) productObj.subTypes = item.subTypes;
      if (item.imageLabels) productObj.imageLabels = item.imageLabels;
      if (item.applicationAreas) productObj.applicationAreas = item.applicationAreas;
      if (item.techSpecs) productObj.techSpecs = item.techSpecs;
      products.push(productObj);
    });
  });
  
  return products;
}

export const products = generateProducts();
